import { useEffect } from "react";
import useDataHandler from "src/components/data-handler/hooks/use-data-handler";
import axiosInstance from "src/utils/axios";

const useCategories = (lang) => {
  const [state, actions] = useDataHandler();

  const fetchCategories = async () => {
    try {
      const { data } = await axiosInstance.get("/api/category", {
        params: { lang: lang },
      });
      const { status, data: categories } = data;

      if (status && categories?.length) {
        actions.success(categories);
      } else {
        actions.success([]);
      }
    } catch (error) {
      actions.error();
      console.error("Category fetch failed", error);
    }
  };

  useEffect(() => {
    actions.loading();
    fetchCategories();
  }, []);

  return { state, fetchCategories };
};

export default useCategories;
